/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import { withDefault } from "@pagopa/ts-commons/lib/types";
import * as t from "io-ts";
import {
  IWithinRangeIntegerTag,
  WithinRangeInteger
} from "@pagopa/ts-commons/lib/numbers";

// required attributes
const StationR = t.interface({
  enabled: withDefault(t.boolean, true),

  station_code: t.string,

  version: t.union([
    WithinRangeInteger<1, 2, IWithinRangeIntegerTag<1, 2>>(1, 2),
    t.literal(2)
  ])
});

// optional attributes
const StationO = t.partial({
  broker_description: t.string,

  is_connection_sync: t.boolean
});

export const Station = t.intersection([StationR, StationO], "Station");

export type Station = t.TypeOf<typeof Station>;
